<div class="tab-pane with-scroll fade active show " id="provider" role="tabpanel" aria-labelledby="provider-tab">

    <div class="no-data with-border d-none">
        <img src="./assets/images/icons/no-data-img.svg" alt="">
        <h4>Looks like there are no groups added yet.</h4>
        <p>Get started by <a>Create New Group</a></p>
    </div>
    <div class="filter-body">
        <div class="filter" *ngIf="showFilter">
            <div class="row" [formGroup]="filterForm">
                <div class="col">
                    <input type="text" class="form-control " id="provider1" formControlName="providerId" placeholder="Provider Code" appPreventFirstSpace>
                </div>
                <div class="col">
                    <input type="text" class="form-control " id="providerName" formControlName="providerName" placeholder="Provider Name" appPreventFirstSpace>
                </div>
                <div class="col">
                    <app-single-select uid="id" [isListing]="true" [searchShow]=true [dataArr]="provType"
                        (selectedEvent)="selectedValue($event,'provType');" label="name"
                        [selectedData]="filterForm.value.provType" [placeholder]="'Provider Type'">
                    </app-single-select>
                </div>
                <div class="col">
                    <app-single-select [isListing]="true" uid="id" [searchShow]=true [dataArr]="status"
                        (selectedEvent)="selectedValue($event,'status');" label="name"
                        [selectedData]="filterForm.value.status" [placeholder]="'Provider Status'">
                    </app-single-select>
                </div>
                <div class="col-2 d-flex">
                    <button id="btnGroupApply" type="button" class="btn btn-dark-blue" (click)="applyFilterOnClick()" [ngClass]="{'disabled':filterForm.invalid}">APPLY</button>
                    <a class="reset-btn" (click)="resetForm()"><span></span>Reset</a>
                </div>
                <div class="col-2" *ngIf="checkPermission('addProvider')">
                    <button id="btnGroupAddNew" (click)="isOpen()" type="button" data-bs-toggle="modal"
                        class="btn btn-primary float-end">
                        ADD New Provider</button>
                </div>
            </div>
        </div>
    </div>

    <div class="table-container table-responsive">
        <table class="table table-list">
            <caption class="d-none">Provider list table body</caption>
            <thead>
                <tr>
                    <th scope="col">PROVIDER#
                        <span *ngIf="providerList.length" class="sort-order" (click)="sortColumn('providerId')">
                            <a class="{{columnSort['providerId'].sortType}} " ></a>
                        </span>
                    </th>
                    <th scope="col">NAME<span *ngIf="providerList.length" class="sort-order"  (click)="sortColumn('providerName')"><a class="{{columnSort['providerName'].sortType}} "></a></span>
                    </th>
                    <th scope="col">PROVIDER CODE <span *ngIf="providerList.length" class="sort-order" (click)="sortColumn('providerCode')"><a class="{{columnSort['providerCode'].sortType}} "></a></span>
                    </th>
                    <th scope="col">TYPE <span *ngIf="providerList.length" class="sort-order" (click)="sortColumn('providerType')"><a class="{{columnSort['providerType'].sortType}} "></a></span>
                    </th>
                    <th scope="col">STATUS <span *ngIf="providerList.length" class="sort-order" (click)="sortColumn('isActive')"><a class="{{columnSort['isActive'].sortType}} "></a></span>
                    </th>
                    <th scope="col">AREA <span *ngIf="providerList.length" class="sort-order" (click)="sortColumn('area')"><a class="{{columnSort['area'].sortType}} "></a></span>
                    </th>
                    <th scope="col">REGULATOR <span *ngIf="providerList.length" class="sort-order" (click)="sortColumn('regulatoryAuthorityCode')"><a class="{{columnSort['regulatoryAuthorityCode'].sortType}} "></a></span></th>
                    <th scope="col">Actions</th>


                </tr>
            </thead>
            <tbody *ngIf=" providerList.length">
                <tr *ngFor="let item of providerList">
                    <td>{{item?.providerId || '-'}}</td>
                    <td>{{item?.providerName || '-'}}</td>
                    <td>{{item?.providerCode || '-'}}</td>
                    <td>{{item?.providerType || '-'}}</td>
                    <td>
                        <div class="status blue-circle-status" *ngIf="item?.isActive ==1 "><span></span>Active</div>
                        <div class="status gray-circle-status" *ngIf="item?.isActive ==2 "><span></span>InActive</div>
                        <div class="status" *ngIf="item?.isActive ==null "><span></span>-</div>
                    </td>
                    <td>{{item?.area || '-'}}</td>
                    <td>{{item?.regulatoryAuthorityCode || '-'}}</td>
                    <td>
                        <ul class="actions">
                            <li *ngIf="checkPermission('editProvider')">
                                <a  id="ProviderEdit" data-bs-toggle="modal"  class="edit-icon tool-wrap position-relative" (click)="showEditPopup(item.providerId)">
                                    <div class="custom-tooltip tooltip-top" role="tooltip">
                                        <div class="arrow"></div>
                                        <div class="tooltip-inner"> Edit </div>
                                      </div>
                                </a>
                            </li>
                            <li *ngIf="checkPermission('viewProvider')">
                                <a data-bs-toggle="modal"  class="view tool-wrap position-relative" (click)="showDetailsPopup(item.providerId)">
                                    <div class="custom-tooltip tooltip-top" role="tooltip">
                                        <div class="arrow"></div>
                                        <div class="tooltip-inner"> View </div>
                                      </div>
                                </a>
                            </li>
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="no-data with-border" *ngIf="!providerList.length">
            <img src="./assets/images/icons/no-data-img.svg" alt="">
            <p>No Results Found</p>

        </div>
    </div>
    <app-navigation [listLength]="totalCount" *ngIf="showNavigation" [pageNo]="page_no" (currentPageDetail)="currentPageDetail($event)" >
    </app-navigation>
</div>
<app-add-provider *ngIf="isAddProvider" (close)="closePopup();isAddProvider=$event;providerId=null;" [providerId]="providerId" ></app-add-provider>
<app-prov-view *ngIf="isViewProvider" (editProvider)='manageEdit()' [providerId]="providerId" [showDetails]='showDetails' (close)="closePopup();isViewProvider=$event;providerId=null;"></app-prov-view>